import { X, Loader2, Download } from "lucide-react";
import FormatDate from "../Common/FormatDate";
import FormatTime from "../Common/FormatTime";

export default function EditHistoryView({ edithistory, seteditmodalopen, editmodalopen, loading }) {

  const STATUS_LABELS = {
    file_updated: "File Updated",
    submitted_to_admin: "Submitted to Admin",
    approved_by_admin: "Approved by Admin",
    submitted_to_account: "Submitted to Accounts",
    approved_by_accounts: "Approved by Accounts",
    file_generated: "File Generated",
    downloaded_by_accounts: "Downloaded by Accounts",
    bank_response_uploaded: "Bank Response Uploaded",
    success: "Success",
    discarded: "Discarded",
    rejected_by_accounts: "Rejected by Accounts",
    rejected_by_admin: "Rejected by Admin",
    file_updated_by_admin: "File Updated by Admin",
    file_to_be_generated: "File to be Regenerated",
    merged_into_parent: "Merged into Parent File",
    unmerged_from_parent: "Unmerged from Parent File",
    file_combined: "Merge File Created"
  };

  const handleDownload = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
      onClick={() => seteditmodalopen(false)}
    >
      <div
        className="bg-white rounded-xl p-6 w-[90vw] max-w-[1400vw] shadow-2xl relative"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-md font-bold text-indigo-900">Edit History</h2>
          <X
            className="h-5 w-5 cursor-pointer text-gray-500 hover:text-gray-700"
            onClick={() => seteditmodalopen(false)}
          />
        </div>

        <div className="max-h-64 overflow-y-auto">
          {loading ? (
            <div className="flex justify-center items-center py-10">
              <Loader2 className="h-6 w-6 animate-spin text-indigo-600" />
            </div>
          ) : edithistory.length === 0 ? (
            <p className="text-center text-gray-400 text-sm py-10">No edit history found</p>
          ) : (
            <table className="w-full border-collapse text-xs">
              <thead className="sticky top-0 z-10">
                <tr className="border-b border-gray-200 bg-[#EFEFEF]">
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold">Edited On</th>
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold">Edited By</th>
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold whitespace-nowrap">Status</th>
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold">Updated Entries</th>
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold">Gross Amount</th>
                  <th className="px-3 py-2 text-center text-blue-700 font-semibold whitespace-nowrap">Food</th>
                  <th className="px-3 py-2 text-center text-blue-700 font-semibold whitespace-nowrap">Bus Deductions</th>
                  <th className="px-3 py-2 text-center text-blue-700 font-semibold whitespace-nowrap">Essentials</th>
                  <th className="px-3 py-2 text-center text-blue-700 font-semibold">Additional Deduction</th>
                  <th className="px-3 py-2 text-center text-blue-700 font-semibold">Promotional / Bonus Amount</th>
                  <th className="px-3 py-2 text-center text-blue-700 font-semibold">Net Amount</th>
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold whitespace-nowrap">Remarks</th>
                </tr>
              </thead>
              <tbody>
                {edithistory.map((row, i) => (
                  <tr key={i} className="border-b border-gray-100">
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">
                      {row?.created_at ? `${FormatDate(row.created_at)} || ${FormatTime(row.created_at)}` : "-"}
                    </td>
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">{row.done_by_name ?? "-"}</td>
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">
                      {STATUS_LABELS[row.status] || row.status || "-"}
                      {row.status === "bank_response_uploaded" && (
<span className="relative group">
  <Download
    className="h-3.5 w-3.5 inline-block ml-1 cursor-pointer text-blue-600 hover:text-blue-800"
    onClick={() => handleDownload(row.response_s3_url)}
  />
  <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap z-50">
    Download Bank Response
  </span>
</span>
                      )}
                    </td>
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">{row.total_entries ?? "-"}</td>
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">{row.total_amount != null ? `₹${row.grossAmount}` : "-"}</td>
                    <td className="px-3 py-2 text-center text-red-500 whitespace-nowrap">{row.total_food_deductions != null ? `-₹${row.total_food_deductions}` : "-"}</td>
                    <td className="px-3 py-2 text-center text-red-500 whitespace-nowrap">{row.total_bus_deductions != null ? `-₹${row.total_bus_deductions}` : "-"}</td>
                    <td className="px-3 py-2 text-center text-red-500 whitespace-nowrap">{row.total_apron_deductions != null ? `-₹${row.total_apron_deductions}` : "-"}</td>
                    <td className="px-3 py-2 text-center text-red-500 whitespace-nowrap">{row.total_additional_deductions != null ? `-₹${row.total_additional_deductions}` : "-"}</td>
                    <td className="px-3 py-2 text-center text-green-500 whitespace-nowrap">{row.total_bonus != null ? `+₹${row.total_bonus}` : "-"}</td>
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">{row.netAmount != null ? `₹${row.netAmount}` : "-"}</td>
                    <td className="px-3 py-2 text-center text-gray-500">{row.rejection_reason_by_admin || row.rejection_reason_by_accounts || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}